import { contactLawyersEndpoint as endpoint } from '../constants/endpointsContants';
import request from './genericRequestService';

async function fetchContactLawyer() {
    return await request.get({ endpoint });
}

export { fetchContactLawyer };
